module.exports = __webpack_public_path__ + "images/5dg53f0fd4d6cc0bc220e0cde2df427323d.svg";